"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDocument = void 0;
var is_document_1 = require("./is-document");
Object.defineProperty(exports, "isDocument", { enumerable: true, get: function () { return is_document_1.isDocument; } });
